<script>
export default {
  name: 'Role',
  props: {
    item: {
      type: Object,
      default: () => {
        return Object
      },
    },
    dialog: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="355">
    <v-card>
      <v-card-title class="headline text-xs-center">
        {{ $t(`label__roles`) }}
      </v-card-title>
      <v-card-text>
        <v-text-field
          :label="$t('label__name')"
          :value="$t(item.i18nKeyName)"
          name="name"
          readonly
        />
        <v-text-field
          :label="$t('label__description')"
          :value="$t(item.i18nKeyDescription)"
          name="description"
          readonly
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="secondary"
          @click.native="$emit('close-dialog')"
        >
          {{ $t('buttons__close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
</style>
